// This file is not yet translated.
/* eslint-disable i18next/no-literal-string */
import type { SxProps } from "@outschool/backpack";
import { lazyWithRetry, useIsMobile } from "@outschool/ui-utils";
import React, { Suspense } from "react";

import { useAllNavbarCategories } from "./navbarCategories";

const DesktopCategoryNavbar = lazyWithRetry(
  () =>
    import(
      /* webpackChunkName: "desktopCategoryNavbar" */ "./DesktopCategoryNavbar"
    ),
);
const DesktopCategoryNavbarButton = lazyWithRetry(
  () =>
    import(
      /* webpackChunkName: "desktopCategoryNavbarButton" */ "./DesktopCategoryNavbarButton"
    ),
);
const MobileCategoryNavbar = lazyWithRetry(
  () =>
    import(
      /* webpackChunkName: "mobileCategoryNavbar" */ "./MobileCategoryNavbar"
    ),
);

export default function CategoryNavbar({
  sx = {},
  useButton,
}: {
  sx?: SxProps;
  useButton?: boolean;
}) {
  const isMobile = useIsMobile();

  const navbarCategories = useAllNavbarCategories();

  return (
    <nav style={{ zIndex: 201, position: "relative" }}>
      <Suspense fallback={null}>
        {isMobile ? (
          <MobileCategoryNavbar categories={navbarCategories} sx={sx} />
        ) : useButton ? (
          <DesktopCategoryNavbarButton categories={navbarCategories} sx={sx} />
        ) : (
          <DesktopCategoryNavbar categories={navbarCategories} sx={sx} />
        )}
      </Suspense>
    </nav>
  );
}

export { default as DesktopCategoryNavbar } from "./DesktopCategoryNavbar";
export { default as MobileCategoryNavbar } from "./MobileCategoryNavbar";
export * from "./navbarCategories";
